// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_math from "../../../../node_modules/rescript/lib/es6/js_math.js";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as PullDownModal$Showside from "./PullDownModal.bs.js";
import * as ReactDOMUtils$Showside from "../utils/ReactDOMUtils.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as IntersectionObserver$Showside from "../utils/IntersectionObserver.bs.js";
function getActiveElement(param) {
  return document.activeElement;
}
function Dropdown(Props) {
  var isOpenOpt = Props.isOpen;
  var mobileOpt = Props.mobile;
  var onOpen = Props.onOpen;
  var onClose = Props.onClose;
  var children = Props.children;
  var classNameOpt = Props.className;
  var label = Props.label;
  var heightOpt = Props.height;
  var widthOpt = Props.width;
  var isOpen = isOpenOpt !== undefined ? isOpenOpt : false;
  var mobile = mobileOpt !== undefined ? mobileOpt : true;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var height = heightOpt !== undefined ? heightOpt : 192;
  var width = widthOpt !== undefined ? widthOpt : 192;
  var match = ViewportContext$Showside.use(undefined);
  var isMobile = match.isMobile && mobile;
  var match$1 = React.useState(function () {
    return false;
  });
  var setOpen = match$1[1];
  var match$2 = React.useState(function () {
    return String(Js_math.random_int(1000, 9999));
  });
  var identifierClassName = "sn-dropdown-" + match$2[0];
  var match$3 = React.useState(function () {
    return false;
  });
  var setHorizontalFlip = match$3[1];
  var ref = React.useRef(null);
  var domRef = ReactDOMUtils$Showside.Ref.domRef(ref);
  var intersection = IntersectionObserver$Showside.use(ref, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  React.useEffect(function () {
    var i = intersection.intersectionRect;
    if (i !== undefined) {
      var b = intersection.boundingClientRect;
      if (b !== undefined) {
        var r = intersection.rootBounds;
        if (r !== undefined) {
          var i$1 = Caml_option.valFromOption(i);
          var horizontalFlip = i$1.x + i$1.width > Caml_option.valFromOption(r).width || Caml_option.valFromOption(b).x < 0.0;
          Curry._1(setHorizontalFlip, function (param) {
            return horizontalFlip;
          });
        }
      }
    }
  }, [intersection]);
  React.useEffect(function () {
    Curry._1(setOpen, function (param) {
      return isOpen;
    });
  }, [isOpen]);
  var matchesActiveElement = function (el) {
    var activeEl = getActiveElement(undefined);
    var activeElClassName = Belt_Option.map(activeEl, function (el) {
      return el.className;
    });
    if (Caml_obj.equal(el.className, activeElClassName)) {
      return true;
    } else {
      return el.contains(activeEl);
    }
  };
  var onFocus = function (param) {
    var el = ref.current;
    if (!(el == null) && matchesActiveElement(el)) {
      return Curry._1(onOpen, undefined);
    }
  };
  var onBlur = function (param) {
    var el = ref.current;
    if (!(el == null) && !matchesActiveElement(el)) {
      return Curry._1(onClose, undefined);
    }
  };
  var style = {
    height: CSS$Showside.intToPx(isOpen ? height : 0),
    width: CSS$Showside.intToPx(width),
    zIndex: "1"
  };
  if (isMobile) {
    var tmp = {
      children: children,
      isOpen: isOpen,
      onClose: onClose,
      fullWidth: true,
      unmount: false
    };
    if (label !== undefined) {
      tmp.label = Caml_option.valFromOption(label);
    }
    return React.createElement(PullDownModal$Showside.make, tmp);
  }
  var tmp$1 = {
    ref: domRef,
    "aria-hidden": !isOpen,
    "aria-modal": true,
    className: Cn.make([identifierClassName, CSS$Showside.prefix("flex transition-all duration-200 ease-in-out rounded-md bg-main px-6 absolute overflow-y-auto overflow-x-hidden"), CSS$Showside.prefix(isOpen ? "shadow-xl pt-5" : "pt-0 shadow-none"), CSS$Showside.prefix(match$3[0] ? "left-0" : "right-0"), CSS$Showside.prefix("top-full"), className]),
    role: "dialog",
    style: style,
    tabIndex: 0,
    onFocus: onFocus,
    onBlur: onBlur
  };
  if (label !== undefined) {
    tmp$1["aria-label"] = Caml_option.valFromOption(label);
  }
  return React.createElement("div", tmp$1, children);
}
Dropdown.displayName = "Dropdown";
var make = Dropdown;
export { getActiveElement, make };
/* react Not a pure module */